var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index,staticClass:"tab",class:{ active: _vm.active - 1 == index },on:{"click":function($event){return _vm.navigate(index)}}},[_c('span',{staticClass:"tab-text"},[_vm._v(_vm._s(tab))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }